<template>
  <v-navigation-drawer
    app
    v-model="sidebarState"
    class="honey-sidebar"
    :mini-variant.sync="mini"
  >
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar class="cursor-pointer">
          <v-icon>account_circle</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="text-center"
            >{{ user.name }}
          </v-list-tile-title>
          <!--          <v-list-tile-sub-title>{{ user.roles[0] }}</v-list-tile-sub-title>-->
        </v-list-tile-content>
        <v-list-tile-action>
          <v-tooltip bottom>
            <v-btn icon ripple @click="logout" slot="activator">
              <v-icon>power_settings_new</v-icon>
            </v-btn>
            <span>Logout</span>
          </v-tooltip>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider></v-divider>

      <template v-for="(item, i) in items">
        <div v-if="item.children" :key="i">
          <v-divider v-show="selectedGroup === item.text"></v-divider>
          <v-list-tile
            @click="
              selectedGroup === item.text
                ? (selectedGroup = null)
                : (selectedGroup = item.text)
            "
            :key="i"
            exact
          >
            <v-list-tile-action>
              <v-tooltip right v-if="mini">
                <v-icon size="20px" slot="activator">
                  {{ item.icon }}
                </v-icon>
                <span>{{ item.text }}</span>
              </v-tooltip>
              <v-icon size="20px" v-else>
                {{ item.icon }}
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon
                >{{
                  selectedGroup === item.text
                    ? 'keyboard_arrow_up'
                    : 'keyboard_arrow_down'
                }}
              </v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-expand-transition>
            <div v-show="selectedGroup === item.text">
              <v-list-tile
                v-for="(child, i) in item.children"
                :key="i"
                @click="
                  selectedItem = child.text
                  goTo(child)
                "
                active-class="$vuetify.theme.secondary"
              >
                <v-list-tile-avatar v-if="child.icon">
                  <v-tooltip right v-if="mini">
                    <v-icon
                      size="18px"
                      slot="activator"
                      :color="
                        child.link.name === $route.name
                          ? $vuetify.theme.secondary
                          : ''
                      "
                    >
                      {{ child.icon }}
                    </v-icon>
                    <span>{{ child.text }}</span>
                  </v-tooltip>
                  <v-icon
                    size="18px"
                    v-else
                    :color="
                      child.link.name === $route.name
                        ? $vuetify.theme.secondary
                        : ''
                    "
                  >
                    {{ child.icon }}
                  </v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    :class="
                      child.link.name === $route.name ? 'secondary--text' : ''
                    "
                    active-class="secondary--text"
                  >
                    {{ child.text }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
            </div>
          </v-expand-transition>
        </div>
        <v-list-tile
          v-else
          @click="
            selectedItem = null
            selectedGroup = null
            goTo(item)
          "
          :key="i"
          :to="item.link"
          exact
        >
          <v-list-tile-action v-if="item && item.link && item.link.name">
            <v-tooltip right v-if="mini">
              <v-icon
                size="20px"
                slot="activator"
                :color="
                  item.link.name === $route.name ? $vuetify.theme.secondary : ''
                "
              >
                {{ item.icon }}
              </v-icon>
              <span>{{ item.text }}</span>
            </v-tooltip>
            <v-icon
              size="20px"
              v-else
              :color="
                item.link.name === $route.name ? $vuetify.theme.secondary : ''
              "
            >
              {{ item.icon }}
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content v-if="item && item.link && item.link.name">
            <v-list-tile-title
              :class="item.link.name === $route.name ? 'secondary--text' : ''"
            >
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import MSALInstance, { BasicAuth } from '../../auth/auth'

export default {
  props: {
    value: Boolean
  },
  computed: {
    ...mapGetters({
      can: 'can'
    }),
    ...mapState({
      user: state => state.session.user,
      minimizeSidebar: state => state.honeyUsers.minimizeSidebar
    })
  },
  data: function() {
    return {
      items: [],
      userRole: '',
      sidebarState: false,
      mini: false,
      selectedGroup: null,
      selectedItem: null
    }
  },
  watch: {
    minimizeSidebar() {
      this.mini = this.minimizeSidebar
    },
    $route(to, from) {
      this.currentRoute = to.name
    },
    sidebarState() {
      this.$emit('input', this.sidebarState)
    },
    value() {
      this.sidebarState = this.value
    }
  },
  async created() {
    this.sidebarState = this.value

    this.currentRoute = this.$route.name
    if (!this.user.name) {
      await this.$store.dispatch('getUserPrincipal')
    }
    if (!this.userSettings) {
      await this.$store.dispatch('fetchUserSettings')
    }
    this.fillSideBar()
    this.mini = this.minimizeSidebar
  },
  methods: {
    add(menuitem, permission) {
      if (this.can(permission)) {
        this.items.push(menuitem)
      }
    },

    addChild(parentmenuid, menuitem, permission) {
      let parent = this.items.find(function(item) {
        return item.id === parentmenuid
      })
      if (parent) {
        if (this.can(permission)) {
          parent.children = parent.children || []
          parent.children.push(menuitem)
        }
      }
    },

    //     {icon: 'home', text: 'My Honey', link: {name: 'home'}},
    //     {icon: 'dashboard', text: 'Honey Dashboard', link: {name: 'dashboard'}},
    //     {icon: 'assignment', text: 'Tulip Tasks', link: {name: 'tasks'}},

    fillSideBar() {
      this.add(
        { icon: 'home', text: 'Home', link: { name: 'home' } },
        'MENU_HOME'
      )
      this.add(
        { icon: 'assignment', text: 'Tasks', link: { name: 'tasks' } },
        'MENU_TASK'
      )
      this.add(
        { id: 'reports', icon: 'analytics', text: 'My Reports', model: false },
        'MENU_TASK'
      )
      this.addChild(
        'reports',
        {
          icon: 'article',
          id: 'task-report',
          text: 'Tasks Report',
          link: { name: 'task-report' }
        },
        'MENU_TASK'
      )
      this.addChild(
        'reports',
        {
          icon: 'support',
          id: 'task-support',
          text: 'Support Tasks',
          link: { name: 'task-support' }
        },
        'MENU_TASK'
      )
      this.add(
        { icon: 'dashboard', text: 'Dashboard', link: { name: 'dashboard' } },
        'MENU_DASHBOARD'
      )
      this.add(
        { id: 'operations', icon: 'build', text: 'Operations', model: false },
        'MENU_OPERATIONS'
      )
      this.addChild(
        'operations',
        {
          icon: 'history',
          id: 'execution-board',
          text: 'Execution History',
          link: { name: 'executions' }
        },
        'MENU_EXECUTIONS'
      )
      this.addChild(
        'operations',
        {
          icon: 'work_outline',
          id: 'job-schedule',
          text: 'Job Schedule',
          link: { name: 'job-schedule' }
        },
        'MENU_SCHEDULE'
      )
      // this.addChild(
      //   'operations',
      //   {
      //     icon: 'calendar_today',
      //     id: 'tulip-calendar',
      //     text: 'Job Calender',
      //     link: { name: 'bot-calendar' }
      //   },
      //   'MENU_CALENDAR'
      // )
      this.addChild(
        'operations',
        {
          icon: 'source',
          id: 'tulip-dms',
          text: 'DMS',
          link: { name: 'tulip-dms' }
        },
        'MENU_CALENDAR'
      )
      this.addChild(
        'operations',
        {
          icon: 'favorite',
          text: 'Tulip Liveness',
          link: { name: 'liveness' }
        },
        'MENU_LANDSCAPE'
      )
      this.addChild(
        'operations',
        {
          icon: 'landscape',
          text: 'Landscape',
          link: { name: 'my-tulip' }
        },
        'MENU_LANDSCAPE'
      )
      this.add(
        {
          id: 'development',
          icon: 'engineering',
          text: 'Development',
          model: false
        },
        'MENU_DEVELOPMENT'
      )
      this.addChild(
        'development',
        {
          icon: 'laptop_chromebook',
          text: 'Automation Services',
          link: { name: 'self-service-list' }
        },
        'MENU_AUTOMATION_SERVICES'
      )
      this.addChild(
        'development',
        {
          icon: 'account_tree',
          text: 'Workflows',
          link: { name: 'workflow-list' }
        },
        'MENU_WORKFLOW'
      )
      this.addChild(
        'development',
        {
          icon: 'adb',
          text: 'Bots',
          link: { name: 'bot-list' }
        },
        'MENU_BOT'
      )
      this.addChild(
        'development',
        {
          icon: 'library_books',
          text: 'Bot Templates',
          link: { name: 'bot-template-list' }
        },
        'MENU_BOT_TEMPLATES'
      )
      this.addChild(
        'development',
        {
          icon: 'device_hub',
          text: 'Automation Agents',
          link: { name: 'hive-list' }
        },
        'MENU_AUTOMATION_AGENTS'
      )
      this.addChild(
        'development',
        {
          icon: 'gavel',
          text: 'Rules',
          link: { name: 'rule-list' }
        },
        'MENU_RULES'
      )
      this.addChild(
        'development',
        {
          icon: 'contact_mail',
          text: 'Identities',
          link: { name: 'identity-list' }
        },
        'MENU_IDENTITIES'
      )
      this.addChild(
        'development',
        {
          icon: 'wc',
          text: 'Profiles',
          link: { name: 'profile-tree-view' }
        },
        'MENU_PROFILE'
      )
      this.addChild(
        'development',
        {
          icon: 'web',
          text: 'Forms',
          link: { name: 'honey-forms' }
        },
        'MENU_FORMS'
      )
      this.addChild(
        'development',
        {
          icon: 'mail',
          text: 'Email Templates',
          link: { name: 'email-templates' }
        },
        'MENU_EMAIL_TEMPLATES'
      )
      this.addChild(
        'development',
        {
          icon: 'code',
          text: 'Proposal Designer',
          link: { name: 'proposal-designer' }
        },
        'MENU_PROPOSAL_TEMPLATE'
      )
      this.add(
        {
          id: 'audit',
          icon: 'account_balance',
          text: 'Audit Reports',
          model: false
        },
        'MENU_AUDIT_REPORT'
      )
      this.addChild(
        'audit',
        {
          icon: 'history',
          id: 'task-history',
          text: 'Completed Task History',
          link: { name: 'task-history' }
        },
        'MENU_USER_TASK_HISTORY'
      )
      this.addChild(
        'audit',
        {
          icon: 'change_history',
          id: 'profile-history',
          text: 'Profile Change History',
          link: { name: 'profile-history' }
        },
        'MENU_PROFILE_CHANGE_HISTORY'
      )
      this.addChild(
        'audit',
        {
          icon: 'change_history',
          id: 'rule-history',
          text: 'Rule Change History',
          link: { name: 'rule-history' }
        },
        'MENU_RULE_CHANGE_HISTORY'
      )
      this.add(
        {
          id: 'package-management',
          icon: 'local_shipping',
          text: 'Package Management',
          model: false
        },
        'MENU_PACKAGE_MANAGEMENT'
      )
      this.addChild(
        'package-management',
        {
          icon: 'file_download',
          id: 'inbound-package',
          text: 'Inbound Package',
          link: { name: 'inbound-package' }
        },
        'MENU_PACKAGE_INBOUND'
      )
      this.addChild(
        'package-management',
        {
          icon: 'file_upload',
          id: 'outbound-package',
          text: 'Outbound Package',
          link: { name: 'outbound-package' }
        },
        'MENU_PACKAGE_OUTBOUND'
      )
      this.add(
        {
          id: 'admin_task',
          icon: 'admin_panel_settings',
          text: 'Admin Tasks',
          model: false
        },
        'MENU_ADMIN_TASK'
      )
      this.addChild(
        'admin_task',
        {
          icon: 'people',
          text: 'Users',
          link: { name: 'user-list' }
        },
        'MENU_USERS'
      )
      this.addChild(
        'admin_task',
        {
          icon: 'assignment_turned_in',
          text: 'Task Maintenance',
          link: { name: 'task-maintenance' }
        },
        'MENU_TASK_MAINTENANCE'
      )
      this.addChild(
        'admin_task',
        {
          icon: 'admin_panel_settings',
          text: 'Role Maintenance',
          link: { name: 'role-maintenance' }
        },
        'MENU_ROLE_MAINTENANCE'
      )
      // this.addChild(
      //   'admin_task',
      //   {
      //     icon: 'build',
      //     text: 'Sync Up Fixes',
      //     link: { name: 'sync-up-fix' }
      //   },
      //   'MENU_SYNC_FIX'
      // )
      this.addChild(
        'admin_task',
        {
          icon: 'build',
          text: 'Tulip Maintenance',
          link: { name: 'tulip-maintenance' }
        },
        'MENU_TULIP_MAINTENANCE'
      )
      // this.addChild(
      //   'admin_task',
      //   {
      //     icon: 'queue',
      //     text: 'Queues',
      //     link: { name: 'rabbitmq' }
      //   },
      //   'MENU_QUEUE_MGMT'
      // )
      // this.addChild(
      //   'admin_task',
      //   {
      //     icon: 'account_tree',
      //     text: 'Workflow Engine',
      //     link: { name: 'camunda' }
      //   },
      //   'MENU_WORKFLOW_MGMT'
      // )
      // this.addChild(
      //   'admin_task',
      //   {
      //     icon: 'trending_up',
      //     text: 'Technical Monitoring',
      //     link: { name: 'monitor' }
      //   },
      //   'MENU_TECH_MON'
      // )
      // this.addChild(
      //   'admin_task',
      //   {
      //     icon: 'assignment',
      //     text: 'Logs',
      //     link: { name: 'beekeeper-logs' }
      //   },
      //   'MENU_LOG'
      // )
      this.add(
        {
          id: 'user-settings',
          icon: 'settings_applications',
          text: 'User Settings',
          model: false
        },
        'MENU_USER_SETTINGS'
      )
      this.addChild(
        'user-settings',
        {
          id: 'personal-access-tokens',
          icon: 'vpn_key',
          text: 'Personal Access Tokens',
          link: { name: 'personal-access-token-list' }
        },
        'MENU_PAT'
      ),
        this.addChild(
          'user-settings',
          {
            id: 'honey-settings',
            icon: 'perm_data_setting',
            text: 'Preferences',
            link: { name: 'honey-settings' }
          },
          'MENU_PREFERENCES'
        )
    },

    goTo: function(item) {
      if (item.link) {
        this.$router.push(item.link).catch()
        if (this.minimizeSidebar) {
          this.mini = !this.mini
        }
      }
    },

    logout() {
      if (MSALInstance.userId === null) {
        BasicAuth.logout()
      } else {
        MSALInstance.logout()
      }
    },

    isCurrentRoute: function(link) {
      if (link && link.name) {
        return this.$route.name === link.name
      }
      return false
    }
  }
}
</script>

<style scoped>
.honey-sidebar {
  z-index: 13;
}
</style>
